<div class="booble-backdrop">
  <div class="xp-modal xp-modal-cadastro">
    <div class="modal-dialog modal-xl modal-dialog-centered modal--xl modal--lg modal--md modal--sm">
      <div class="modal-content">
        <div class="modal-header">
          <div class="col-md-12">
            <div class="header-title">Novo envio</div>
            <p class="header-subtitle">Selecione e preencha os campos abaixo para solicitar envio.</p>
          </div>
          <button type="button" (click)="closeModal()" class="btn-close" data-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <form [formGroup]="finalityForm" class="modal-body">

          <div class="modal-dialog-scrollable-general">
            <p class="type-title">Para quem você quer enviar ?</p>

            <div class="row d-flex justify-content-center gap-3">
  
              <div class="col-md col-sm col-xl-6 col-xs-12 col-mobile">
                <div [ngClass]="!finality.thirdPartyOrder && finality.thirdPartyOrder !== null ? 'card-selected' : ''"
                (click)="selectOrderForMe()" class="card-orders">
                <div style="display: flex; justify-content: center">
                  <img src="assets/image/for-me.svg" alt="" />
                </div>
  
                <p class="title-card">Mesma titularidade</p>
  
                <p class="description-card">
                  Envie dinheiro para você mesmo no exterior
                </p>
              </div>
              </div>
  
              <div class="col-md col-sm col-xl-6 col-xs-12 col-mobile">
                <div [ngClass]="finality.thirdPartyOrder ? 'card-selected' : ''" (click)="selectThirdPartyOrder()"
                class="card-orders">
                <div style="display: flex; justify-content: center">
                  <img src="assets/image/third-party-icon.svg" alt="" />
                </div>
  
                <p class="title-card">Titularidade diferente</p>
  
                <p class="description-card">
                  Envie dinheiro para outra pessoa ou empresa
                </p>
              </div>
              </div>
            </div>
          
            <div class="form-row">
              <div class="col-lg-6 col-md-6">
                <div class="line">
                  <div class="label"><span class="text-danger">* </span>Finalidade</div>
                  <select placeholder="Selecione" (ngModelChange)="filterFinality($event)" formControlName="finalityType"
                    class="custom-select js-control-finality-type" name="finalityType">
                    <option value="SERVICES">Serviços</option>
                    <option value="IMPORT">Importação</option>
                    <option value="OTHER">Outros</option>
                  </select>
                </div>
              </div>
  
  
              <div class="col-lg-6 col-md-6" [ngStyle]="{'display': !showFinalityIdSelect ? 'none' : ''}">
                <div class="line">
                  <div class="label"><span class="text-danger">* </span>Especificação de finalidade</div>
                  <select placeholder="Selecione" formControlName="finalityId"
                    class="custom-select js-control-finality-id" name="finalityId">
                    <option *ngFor="let finality of filteredFinalities" [ngValue]="finality.id">
                      {{finality.description}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
  
            <div class="btn-content">
              <button [ngClass]="{'btn-gray-disabled': finalityForm.invalid , 'btn-blue-30': !finalityForm.invalid}"
                [disabled]="finalityForm.invalid" (click)="goToInvoiceModal()" type="button"
                class="btn-xp-m2 btn-blue-30">
                Avançar
              </button>
  
            </div>
          </div>
         
        </form>
      </div>
    </div>
  </div>
</div>